type DealWorkflowRestrictionByResourceType = {
	downloadable: boolean;
	locked: boolean;
	startable: boolean;
	unlockable: boolean;
};

export type DealWorkflowRestriction = {
	canForwardToInConstruction: boolean;
	estimation: DealWorkflowRestrictionByResourceType;
	ownerBilling: DealWorkflowRestrictionByResourceType;
};

// ロック中は編集操作を隠すため、編集できない理由と、編集できるようにするための次の操作を文言にする
export const buildWorkflowLockMessage = (
	restriction: DealWorkflowRestrictionByResourceType,
	targetLabel: string
): string | null => {
	if (!restriction.locked) {
		return null;
	}
	// ワークフローの開始時に必ずロックされ、進行中は解除できないため、ロック中で解除できない場合は進行中とみなせる
	if (!restriction.unlockable) {
		return `進行中のワークフローがあるため、${targetLabel}の編集とワークフローの開始はできません。`;
	}
	return `${targetLabel}がロックされています。編集するには、編集ロックを解除してください。`;
};
